// extracted by mini-css-extract-plugin
export var formContainer = "_d2-0";
export var message = "_d2-1";